import React from 'react';

export default ({ trackingUrl }) =>
  <div className="addtl-order-details">
    <div>
      <span className="mar-r-5">Your order has shipped!</span>
      <a className="tracking-link" href={trackingUrl} target="_blank">
        <span className="mar-r-5" >Track Shipment</span>
        <i className="fa fa-caret-right" />
      </a>
    </div>
  </div>